import React,{useState} from "react";
import Modal from '../../component/Inc/Modal';
import Chat from "../../component/Inc/Chat";
import ImgProfile from 'contents/assets/img/@profile.png';
import BtnLike from "../../component/Inc/BtnLike";//좋아요 버튼
function PopChatting(props) {
  const { open, close } = props;
  const [tabIdx, setTabIdx] = useState(0);
  const [isSelected] = useState(-1);
  const [openChat, setOpenChat] = useState(false);
  const tab = [
    {title:"친구 목록", value:0},
    {title:"채팅 목록", value:1},
  ];
  return (
    <Modal open={open} close={close} type="pop_chatting">
      {!openChat &&
        <>
          <h2 className='pop_tit'>채팅</h2>
          <div className="com_btn_wrap center">
            { tab.map((item,idx) => {
              return (
                <button 
                  key={idx} 
                  className={`com_btn s ${idx === 0 ? "btn_chatting":idx === 1 ? "btn_chatting_list" : ''} ${tabIdx === item.value ? "active" : ""}`} 
                  onClick={() => setTabIdx(item.value)}
                >
                  {item.title ? item.title : ``}
                </button>
              )
            })}
          </div>
          <article className='search'>
            <input type="search" placeholder='채팅명(이름) 검색' className="input" />
            <button className="com_btn gray ws xs icon_search"></button>
          </article>
          <div className="content_container scroll">
            {tabIdx === 0 ? 
            <ul className="plain_list">
              {[...Array(20)].map((_, idx) => (
                <li onClick={() => setOpenChat(true)} className="item" key={idx} >
                  <button className="link">홍길동{105 + idx}</button>
                </li>
              ))}
            </ul>
            :
            <ul className="chat_list">
              {[1,2,3,4,5,6,7,8,9,10].map((i,idx) => {
                return (
                <li onClick={() => setOpenChat(true)} className={`item ${isSelected === i - 1 ? 'isActive' : ''}`} key={idx}>
                  <p className="thumb">
                    <img src={ImgProfile} alt="profile" />
                  </p>
                  <div className="info_box">
                    <p className="name">홍길동103 (영어)</p>
                    <p className="desc">안녕하세요 12월에 입사한 이주영입니다. 미래를 만드는 이지와 함께 성장하고 싶습니다~~~~~</p>
                  </div>
                  <BtnLike/>
                </li>
                )
              })}
            </ul>
            }
          </div>
        </>
      }

      {/* detail */}
      {openChat &&
        <>
          <h2 className="chat_detail_tit"><button onClick={() => {setOpenChat(false)}} className="btn_back"/>채팅 목록</h2>
          <Chat />
        </>
      }
    </Modal>
  );
}

export default PopChatting;